module.exports = __webpack_public_path__ + "img/transparent-1000.6fec7f54.png";